import React, { useEffect, useState } from "react";
import { Send, Loader2, MessageCircle, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { AttachmentUploader } from "./SupportTicketBits";
import { CAT_ICONS } from "./SupportFaq";

// New ticket: category cards → subject → description → attachments (≥0, max 5) → submit. Calls onCreated(ticket).
export function SupportTicketForm({ onCreated, initialCategory = "" }) {
  const [cats, setCats] = useState([]);
  const [f, setF] = useState({ category: initialCategory, subject: "", description: "", attachments: [] });
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/support/categories").then((r) => setCats(r.data.items)).catch(() => {}); }, []);
  const valid = f.category && f.subject.trim().length >= 5 && f.description.trim().length >= 10;
  const submit = async (e) => {
    e.preventDefault();
    if (!valid || busy) return;
    setBusy(true);
    try {
      const r = await api.post("/support/tickets", { ...f, subject: f.subject.trim(), description: f.description.trim(), context: { page: window.location.pathname, user_agent: navigator.userAgent.slice(0, 200), screen: `${window.innerWidth}x${window.innerHeight}` } });
      toast.success(`Tiket ${r.data.number} terkirim — kami kabari lewat lonceng & email`);
      onCreated?.(r.data);
    } catch (err) { toast.error(err?.response?.data?.detail || "Gagal mengirim tiket"); } finally { setBusy(false); }
  };
  const lbl = "mb-1.5 block text-xs font-bold uppercase tracking-wider text-slate-500";
  return (
    <form onSubmit={submit} className="space-y-5" data-testid="ticket-form">
      <div>
        <span className={lbl}>Kategori</span>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3" data-testid="ticket-category-picker">
          {cats.map((c) => { const I = CAT_ICONS[c.icon] || MessageCircle; const on = f.category === c.id; return (
            <button key={c.id} type="button" onClick={() => setF({ ...f, category: c.id })} data-testid={`ticket-cat-${c.id}`} aria-pressed={on}
              className={`flex items-start gap-3 rounded-2xl border p-3 text-left transition ${on ? "border-[#2F6BFF] bg-[#EEF3FF] shadow-sm" : "border-[#E6EAF2] bg-white hover:border-[#2F6BFF]/40"}`}>
              <span className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-xl ${on ? "bg-[#2F6BFF] text-white" : "bg-slate-100 text-slate-500"}`}><I size={15} /></span>
              <span className="min-w-0"><span className="block text-sm font-semibold text-slate-800">{c.label}</span><span className="line-clamp-2 text-[11px] text-slate-500">{c.desc}</span></span>
              {on && <CheckCircle2 size={16} className="ml-auto shrink-0 text-[#2F6BFF]" />}
            </button>); })}
        </div>
      </div>
      <div>
        <label className={lbl} htmlFor="ticket-subject">Subjek</label>
        <input id="ticket-subject" value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} maxLength={160} placeholder="Ringkas masalahmu dalam satu kalimat" className="input-dark w-full py-2.5 text-sm" data-testid="ticket-subject" />
      </div>
      <div>
        <label className={lbl} htmlFor="ticket-desc">Deskripsi</label>
        <textarea id="ticket-desc" value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} rows={6} maxLength={6000}
          placeholder={"Ceritakan detailnya:\n• Apa yang kamu lakukan?\n• Apa yang terjadi / pesan error?\n• Kapan kejadiannya (tanggal & jam)?"} className="input-dark w-full resize-y py-2.5 text-sm leading-relaxed" data-testid="ticket-description" />
        <p className="mt-1 text-right text-[10px] text-slate-400">{f.description.length}/6000</p>
      </div>
      <div>
        <span className={lbl}>Lampiran <span className="font-normal normal-case tracking-normal text-slate-400">(opsional, maks 5)</span></span>
        <AttachmentUploader value={f.attachments} onChange={(attachments) => setF({ ...f, attachments })} />
      </div>
      <div className="flex items-center justify-end gap-3 border-t border-[#EEF1F6] pt-4">
        <p className="mr-auto text-[11px] text-slate-400">Balasan dikirim ke lonceng notifikasi & email akunmu.</p>
        <button type="submit" disabled={!valid || busy} className="btn-primary flex items-center gap-2 rounded-xl px-5 py-2.5 text-sm" data-testid="ticket-submit">{busy ? <Loader2 size={15} className="animate-spin" /> : <Send size={15} />} Kirim Tiket</button>
      </div>
    </form>
  );
}
